// 홈 전용 데이터. 확정 디자인 HfHome의 renderVals 내용. 이력서 PDF와 문구를 맞춘다 (기능정의서 3편 4장).

export const HERO = {
  eyebrow: "이광복, AI 네이티브 엔지니어",
  headline: ["한 사람의 요령을", "팀 전체의 기본값으로."],
  intro:
    "스킬 체이닝, 커맨드, 훅으로 Claude Code 하네스를 설계해 코드 컨벤션 검증, PR 작성, 기획서 엣지케이스 검증을 자동화했습니다. 누가 실행해도 같은 절차와 검증 게이트를 거치고, 프로젝트 전체 테스트 커버리지는 100%를 유지합니다. 2016년 백엔드 개발자로 시작해 10년간 백엔드와 인프라를 맡아 왔습니다. 지금은 프로덕트 엔지니어로 문제 정의부터 기획, 개발, 배포까지 직접 맡아 AI 기반 제품을 만들고 있습니다.",
};

// 시스템 다이어그램의 전문성 노드. core 노드와 선으로 잇는다.
export const SKILLS = [
  { key: "backend", value: "Spring Boot, NestJS, FastAPI" },
  { key: "data", value: "PostgreSQL, OpenSearch, Redis" },
  { key: "devops", value: "AWS, Terraform, CI/CD" },
  { key: "ai", value: "AI 에이전트 워크플로" },
  { key: "quality", value: "TDD, 커버리지 100%" },
  { key: "lead", value: "팀 리드, 일정 안에 출시" },
];

// career 클러스터 아래 요약 줄. 이력서 기준 2016.05부터 경력 10년.
export const CAREER_TOTAL = { since: "2016.05", years: 10 };

// career 클러스터. 최근 회사 3곳, 첫 칸은 현재 회사.
export const CAREER_CLUSTER = [
  { name: "셀타스퀘어, AI1팀 팀장", period: "2025.08 ~", highlight: "AI 검토 도구 12일 PoC, 식약처 과제 변환 도구, 완전 IaC" },
  { name: "카운터포인트리서치, 팀장", period: "2025.02 ~ 08", highlight: "레거시 2명 4개월 재구축, 서버 비용 75% 절감" },
  { name: "아비투스어소시에이트, 팀장", period: "2023.08 ~ 2025.02", highlight: "아트페어 일정에 맞춘 10일 개발, OpenSearch 검색" },
];

export type CommitType = "lead" | "refactor" | "test" | "infra" | "ci" | "feat" | "perf";

export interface Branch {
  company: string;
  meta: string; // 기간과 직함
  dot: string; // 브랜치 머리 색
  commits: { type: CommitType; title: string }[];
}

// 경력 git log. 회사는 브랜치, 성과는 커밋. 최신 회사부터.
export const CAREER_LOG: Branch[] = [
  {
    company: "셀타스퀘어",
    meta: "2025.08 ~ 현재, AI Native 엔지니어, AI1팀 팀장",
    dot: "#B8341F",
    commits: [
      { type: "feat", title: "Claude Skill 코드 컨벤션 자동 검증, AI 기반 PR 자동 생성, 기획서 엣지케이스 검증기 도입" },
      { type: "feat", title: "PMS 결과보고서 AI 1차 검토 도구를 PM 겸 1인 개발로 12일 만에 PoC 배포, 현업 시연과 사내 제안 발표, 정식 전환 계획까지 진행" },
      { type: "feat", title: "식약처 연구용역 맞춤형 제공 모델 중 KAERS 원시자료 변환 도구 개발 담당, 폐쇄망 무설치 패키지, 최종 평가 셀 불일치 0건으로 합격" },
      { type: "infra", title: "식약처 AS2 전자보고 복호화 장애 원인(공개키 불일치)을 찾아 해결, EC2 단일 서버를 Lambda 서버리스로 재구축" },
      { type: "test", title: "TDD와 AI 자동화로 프로젝트 전체 커버리지 100% 유지, 프론트엔드 없이 백엔드 단독 E2E 시나리오 구축" },
      { type: "refactor", title: "Python 레거시를 NestJS로 전환하며 아키텍처 재설계, Blue-Green 무중단 배포, 하위 호환성 유지 정책" },
      { type: "infra", title: "Terraform Cloud IaC 저장소를 혼자 시작해 워크스페이스 34개로 확장, Jenkins, GitHub Actions 분기형 스크립트를 CodePipeline, CodeBuild, CodeDeploy와 Terraform Cloud로 코드화" },
      { type: "ci", title: "수동 DDL을 ORM과 Migration 파일 기반으로 전환, 휴먼 에러가 생기는 구조 제거" },
      { type: "lead", title: "5~8인 팀, OKR 분기 목표 관리, 기획팀과 PV팀 R&R 명문화" },
    ],
  },
  {
    company: "카운터포인트리서치",
    meta: "2025.02 ~ 2025.08, 팀장, Senior Backend & DevOps Engineer",
    dot: "#3A4A66",
    commits: [
      { type: "refactor", title: "6명이 1년간 개발한 레거시 웹 서비스를 2명이 4개월 만에 재구축" },
      { type: "perf", title: "FinOps 도입으로 연간 서버 비용 1.6억 원을 4천만 원 수준으로, 75% 절감" },
      { type: "infra", title: "Terraform 기반 CodePipeline, ECR, ECS 파이프라인 구축" },
    ],
  },
  {
    company: "아비투스어소시에이트",
    meta: "2023.08 ~ 2025.02, 프로덕트팀 팀장",
    dot: "#3A4A66",
    commits: [
      { type: "feat", title: "아트페어 일정에 맞춰 ARTUE를 제로베이스에서 10일 만에 오픈" },
      { type: "feat", title: "PostgreSQL LIKE 검색을 OpenSearch로 대체, CRUD 이벤트 기반 실시간 자동 인덱싱, 복합 조건 검색" },
      { type: "infra", title: "Terraform IaC 도입, Public, Private Subnet 분리와 Bastion Host로 VPC 망 분리" },
    ],
  },
  {
    company: "헬스포트",
    meta: "2021.01 ~ 2023.07, 개발팀 팀장",
    dot: "#3A4A66",
    commits: [
      { type: "perf", title: "N+1 해결과 인덱스 재설계로 주요 API 조회 성능 20배 이상 향상" },
      { type: "ci", title: "Jenkins, AWS CodeDeploy, ELB로 무중단 배포 자동화, ApacheMQ로 장애 전파 방지" },
    ],
  },
  {
    company: "이전 경력",
    meta: "2016.05 ~ 2020.12, 디바인테크, 보나캠프, 아사달",
    dot: "#8A96AB",
    commits: [{ type: "feat", title: "국가 주요기관 공공 SI, 한미약품 약국 자동화 시스템 설계와 개발" }],
  },
];

// 전문성 표. area, stack, evidence. key는 홈 다이어그램 노드(SKILLS)가 #cap-<key>로 가리킨다.
export const CAPABILITIES = [
  { key: "backend", area: "Backend", stack: "Java, Spring Boot, NestJS, FastAPI, TypeScript, Python, Serverless", evidence: "Python 레거시를 NestJS로 전환하며 아키텍처 재설계, 서비스 규모와 비용에 맞춰 프레임워크 선택" },
  { key: "data", area: "Data", stack: "PostgreSQL, MariaDB, Oracle, OpenSearch, Redis, DynamoDB", evidence: "N+1 해결과 인덱스 재설계로 주요 API 조회 성능 20배 이상 향상, LIKE 검색을 OpenSearch로 대체" },
  { key: "devops", area: "Infra, DevOps", stack: "AWS, Terraform, Docker, Kubernetes, Helm, ArgoCD", evidence: "배포 파이프라인 완전 IaC, Blue-Green 무중단 배포, FinOps로 연간 서버 비용 75% 절감" },
  { key: "quality", area: "Quality", stack: "TDD, E2E 테스트", evidence: "프로젝트 전체 테스트 커버리지 100% 유지" },
  { key: "ai", area: "AI 개발", stack: "Claude Code, Codex, Gemini, OpenCode, 스킬, 훅, 서브에이전트, MCP", evidence: "개인 플러그인 마켓플레이스에서 Claude Code와 Codex가 같이 쓰는 스킬 40여 개를 운영하고 스킬끼리 체이닝. 팀에는 코드 컨벤션 자동 검증, AI PR 자동 생성, 기획서 엣지케이스 검증기를 정착" },
  { key: "lead", area: "Leadership", stack: "팀 리드", evidence: "6명이 1년간 만든 레거시를 2명이 4개월 만에 재구축, 아트페어 일정에 맞춰 ARTUE를 10일 만에 오픈" },
];
